/***********
 * 项目描述 
 **************/
import LaborDetailTitleValue from "./LaborDetailTitleValue.vue";
export default {
  components: {
    LaborDetailTitleValue
  },
  props: {
    laboratoryItemDetail: {
      type: Object
    },
    moudleName: {
      type: String
    }
  },

  mounted() {
    console.log(this.laboratoryItemDetail, 'laboratoryItemDetail');
  },

  data() {
    return {};
  }

};